/* CB1000GT Store: pure logic for the delivery estimate (snippets/cb-delivery-estimate.liquid).
 * No DOM here, so it can be unit-tested in Node (cb1000gtstore-project/tools/hoco-stock-sync/delivery-logic.test.mjs).
 *
 * States for products tagged `Hoco` (spec 2026-09-26):
 *   A  own stock > 0                          -> Tue–Sat before 16:00 (Amsterdam) ships the same day,
 *                                                 otherwise the next shipping day (Tue–Sat; closed Monday)
 *   B  own 0, Hoco in stock, checked < 26 h   -> ordered at Hoco Mon–Fri (before 16:00 = today),
 *                                                 delivered to us and shipped the next day
 *   C  anything else                          -> on request
 */
(function (root) {
  var CHECK_MAX_AGE_MS = 26 * 3600 * 1000;
  var CUTOFF_HOUR = 16;
  var DAY_MS = 86400000;

  function pickState(v, now) {
    if (!v) return 'C';
    if (v.own) return 'A';
    if (v.hoco === 'in_stock' && v.checked) {
      var age = now.getTime() - Date.parse(v.checked);
      if (age >= 0 && age < CHECK_MAX_AGE_MS) return 'B';
    }
    return 'C';
  }

  // Calendar date + hour in Europe/Amsterdam; `day` is a UTC-midnight timestamp of that calendar date.
  function amsParts(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).forEach(function (p) { parts[p.type] = p.value; });
    return {
      day: Date.UTC(+parts.year, +parts.month - 1, +parts.day),
      hour: +parts.hour,
      minute: +parts.minute
    };
  }

  // Selling Motorbikes is closed on Monday: we ship Tuesday–Saturday.
  // Orders to Hoco go out Monday–Friday; Hoco delivers the next day (so Tuesday–Saturday).
  function weekday(dayMs) { return new Date(dayMs).getUTCDay(); }
  function isShipDay(dayMs) { var wd = weekday(dayMs); return wd >= 2 && wd <= 6; }
  function isHocoOrderDay(dayMs) { var wd = weekday(dayMs); return wd >= 1 && wd <= 5; }

  function nextDay(dayMs, pred) {
    var d = dayMs + DAY_MS;
    while (!pred(d)) d += DAY_MS;
    return d;
  }

  function shipDaysBetween(fromDay, toDay) {
    var n = 0;
    for (var d = fromDay + DAY_MS; d <= toDay; d += DAY_MS) if (isShipDay(d)) n++;
    return n;
  }

  // -> { dispatch: UTC-midnight ms, workdays: shipping days after today, today: bool } ; null for state C.
  //   A (own stock): Tue–Sat before 16:00 -> same day, otherwise the next shipping day.
  //   B (Hoco):      Hoco order day (Mon–Fri before 16:00 = today, else the next one) + 1 day.
  function dispatchInfo(state, now) {
    if (state !== 'A' && state !== 'B') return null;
    var p = amsParts(now);
    var early = p.hour < CUTOFF_HOUR;
    var dispatch;
    if (state === 'A') {
      dispatch = isShipDay(p.day) && early ? p.day : nextDay(p.day, isShipDay);
    } else {
      var orderDay = isHocoOrderDay(p.day) && early ? p.day : nextDay(p.day, isHocoOrderDay);
      dispatch = orderDay + DAY_MS;
    }
    return { dispatch: dispatch, workdays: shipDaysBetween(p.day, dispatch), today: dispatch === p.day };
  }

  // Fixed English names: Intl month abbreviations differ per browser ("Sep" vs "Sept").
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function formatDate(dayMs) {
    var d = new Date(dayMs);
    return WD[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()];
  }

  // "3-4" + 1 -> "4-5" ; "1" + 2 -> "3"
  function deliveryRange(postnl, extra) {
    return String(postnl).split('-').map(function (n) { return String(+n + (extra || 0)); }).join('-');
  }

  root.CBDelivery = {
    pickState: pickState, amsParts: amsParts, dispatchInfo: dispatchInfo,
    formatDate: formatDate, deliveryRange: deliveryRange
  };
})(typeof window !== 'undefined' ? window : this);
